import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from "@mui/material";
import { useState } from "react";
import { notifyOperator, postSendPopupToSomeone } from "../../Operator/OperatorAPI/OperatorPost";

const UserPopupDialog = ({ onClose, user }) => {
  const [message, setMessage] = useState("");

  const sendPopup = async () => {
    if (!user || !message.trim()) return;
    const result = await postSendPopupToSomeone(user.id, message);
    if (result.ok) {
      notifyOperator(`הפופאפ נשלח ל${user.name}`, "success");
    }
    onClose();
  };

  return (
    <Dialog open={true} onClose={onClose}>
      <DialogTitle dir="rtl">שלח הודעת פופאפ ל{user?.name}</DialogTitle>
      <DialogContent>
        <DialogContentText dir="rtl">
          הודעה זו תופיע כחלון קופץ על מסך הנבחן ולא תעצור את המבחן.
        </DialogContentText>
        <TextField
          autoFocus
          margin="dense"
          label={`הודעה ל${user?.name}`}
          type="text"
          fullWidth
          dir="rtl"
          value={message}
          onChange={e => setMessage(e.target.value)}
          onKeyDown={e => e.key === "Enter" && sendPopup()}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>ביטול</Button>
        <Button onClick={sendPopup} variant="contained" color="primary" disabled={!message.trim()}>
          שלח
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UserPopupDialog;
